import { FC } from 'react';
import styles from './Hero.module.scss';

export interface HeroProps {
  label?: string;
  heading?: string;
  description?: string;
  buttonText?: string;
  buttonHref?: string;
}

export const Hero: FC<HeroProps> = ({
  label = 'A CLEARER WAY TO FIND WHAT MATTERS',
  heading = 'Everything about the building, connected.',
  description = 'Search assets, drawings, manuals and design information from one place—then follow the relationships between them.',
  buttonText = 'Explore electrical drawings',
  buttonHref = '/more-info',
}) => {
  return (
    <section className={styles.heroContainer} aria-labelledby="hero-heading">
      <div className={styles.content}>
        <span className={styles.label}>{label}</span>
        <h2 id="hero-heading" className={styles.heading}>
          {heading}
        </h2>
        <p className={styles.description}>{description}</p>
        <a href={buttonHref} className={styles.actionButton}>
          {buttonText}
        </a>
      </div>

      <div className={styles.decorativePattern} aria-hidden="true">
        <svg viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
          <circle cx="250" cy="250" r="230" stroke="rgba(255, 255, 255, 0.08)" strokeWidth="48" />
          <circle cx="250" cy="250" r="170" stroke="rgba(255, 255, 255, 0.12)" strokeWidth="24" />
          <circle cx="250" cy="250" r="110" stroke="rgba(255, 255, 255, 0.16)" strokeWidth="12" />
        </svg>
      </div>
    </section>
  );
};
